// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2fmu4","label":"Completed_label__2oy_4"};